// components/addDeviceGroupModal.component.js
import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
} from '@chakra-ui/react';

const AddDeviceGroupModal = ({ isOpen, onClose, onSave }) => {
  const [groupName, setGroupName] = useState('');

  const handleSave = () => {
    onSave(groupName); // `onSave`'e yalnızca `groupName` string değerini gönderiyoruz
    setGroupName(''); // Girdi alanını temizle
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Device Group</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="Enter group name"
            value={groupName}
            onChange={e => setGroupName(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleSave}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose} ml={3}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddDeviceGroupModal;
